import { TextField, useMediaQuery } from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import "dayjs/locale/fr";
import "dayjs/locale/es";
import "dayjs/locale/en";
import "dayjs/locale/pl";
import { useTranslation } from "react-i18next";
import { mappedLanguages } from "config/helpers/common_helper";

const UIDatePicker = ({
  value = "",
  onChange = () => {},
  fullWidth = true,
  error = false,
  minDate = null,
  maxDate = null,
  sx,
  disableDate,
  disablePast = false,
  disableFuture = false,
  placeholder = "",
  size,
  helperText,
  label,
  placement = "auto", // default placement value
  required = true,
  ...props
}) => {
  const theme = useSelector((state) => state?.app?.theme);
  const isMobile = useMediaQuery("(max-width:767px)");
  const { i18n } = useTranslation();

  return (
    <div>
      <LocalizationProvider
        dateAdapter={AdapterDayjs}
        adapterLocale={mappedLanguages?.[i18n?.language]?.languageCode || "en"}
      >
        <DesktopDatePicker
          minDate={minDate}
          maxDate={maxDate}
          value={value}
          disabled={disableDate}
          onChange={(date) => {
            let event = {
              target: {},
            };
            event.target.name = props?.name;
            event.target.value = date;
            onChange(event);
          }}
          sx={{
            ...sx,
            "& .MuiFormHelperText-root": {
              color: error ? "#D32F2F" : "inherit",
            },
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: error ? "#D32F2F" : "inherit",
              },
            },
          }}
          PopperProps={{
            placement: placement,
            // modifiers: [
            //   {
            //     name: "flip",
            //     options: {
            //       // altBoundary: true,
            //       rootBoundary: "viewport",
            //     },
            //   },
            //   {
            //     name: "preventOverflow",
            //     options: {
            //       // altAxis: true, // Allows the popper to switch to the opposite axis if it's about to overflow
            //       altBoundary: true,
            //       tether: true,
            //       rootBoundary: "viewport",
            //     },
            //   },
            // ],
            sx: { zIndex: 1000000 }, // Ensure a high zIndex for visibility
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              // sx={{fontSize:isMobile?"1.2vh":"0.8vw"}}
              fullWidth={fullWidth}
              error={error}
              InputProps={{
                ...params.InputProps,
                style: { fontWeight: "500" },
                startAdornment: (!value && required) ? (
                  <span position="start" style={{ color: "red", marginLeft: props?.adaptiveScreen&&"-0.2rem" }}>
                    *
                  </span>
                ) : null,
              }}
              inputProps={{
                ...params.inputProps,
                style: {
                  color: theme === "dark" ? "white" : "#222",
                  opacity: 1,
                  fontWeight: "500",
                },
                placeholder: placeholder, // Default placeholder
                onFocus: (e) => {
                  e.target.placeholder =
                    mappedLanguages?.[i18n?.language]?.dateFormat; // Placeholder when focused
                },
                onBlur: (e) => {
                  e.target.placeholder = placeholder; // Placeholder when not focused
                },
              }}
              helperText={helperText}
            />
          )}
          {...props}
        />
      </LocalizationProvider>
    </div>
  );
};

export default UIDatePicker;
